import { useState, useEffect } from 'react';
import { ethers } from 'ethers';
import './App.css';

function App() {
  // 🔹 STATE MANAGEMENT - untuk simpan data dynamic
  const [account, setAccount] = useState(''); // Alamat wallet user
  const [token, setToken] = useState(null); // Instance contract token
  const [balance, setBalance] = useState('0'); // Balance token user
  const [toAddress, setToAddress] = useState(''); // Alamat penerima transfer
  const [transferAmount, setTransferAmount] =useState(''); // Jumlah transfer
  const [mintAmount, setMintAmount] =useState('');
  const [isConnected, setIsConnected] = useState(false); // Status koneksi wallet

  // 🔹 ABI (Application Binary Interface) - Daftar function yang bisa dipanggil di contract
  // Ini seperti "interface" untuk berkomunikasi dengan smart contract
  const tokenABI = [
    // Function-function yang ada di DeepthinkToken.sol
    "function name() view returns (string)",
    "function symbol() view returns (string)", 
    "function decimals() view returns (uint8)",
    "function totalSupply() view returns (uint256)",
    "function balanceOf(address) view returns (uint256)",
    "function transfer(address to, uint256 amount) returns (bool)",
    "function mint(address to, uint256 amount)",
    "function owner() view returns (address)",
    "function burn(uint256 amount)",
    "event Transfer(address indexed from, address indexed to, uint256 value)"
  ];

  // 🔹 CONTRACT ADDRESS - Ganti dengan address contract Anda yang sudah di-deploy!
  const contractAddress = process.env.REACT_APP_CONTRACT_ADDRESS || "0x52D081F4217a8618D3fCc89eBa32D6E2FC7421b8";
const network = process.env.REACT_APP_NETWORK || "sepolia";

  // 🔹 FUNCTION: CONNECT WALLET KE DAPP
  const connectWallet = async () => {
    // Cek apakah MetaMask terinstall
    if (window.ethereum) {
      try {
        console.log("🦊 Connecting to MetaMask...");
        
        // 🔹 Minta akses ke akun MetaMask user
        // Ini akan memunculkan popup persetujuan di MetaMask
        const accounts = await window.ethereum.request({ 
          method: 'eth_requestAccounts' 
        });
        
        // 🔹 Simpan alamat wallet user ke state
        const userAddress = accounts[0];
        setAccount(userAddress);
        setIsConnected(true);
        console.log("✅ Connected to:", userAddress);

        // 🔹 SETUP PROVIDER & SIGNER
        // Provider = koneksi ke blockchain network
        // Signer = user yang bisa sign transactions
        const provider = new ethers.BrowserProvider(window.ethereum);
        const signer = await provider.getSigner();
        
        // 🔹 BUAT CONTRACT INSTANCE
        // Gabungkan address contract, ABI, dan signer
        const tokenContract = new ethers.Contract(
          contractAddress, 
          tokenABI, 
          signer
        );
        setToken(tokenContract);
        console.log("📝 Contract instance created");

        // 🔹 AMBIL DATA AWAL: Balance dan info token
        await fetchTokenData(tokenContract, userAddress);
        
      } catch (error) {
        console.error("❌ Error connecting wallet:", error);
        alert("Gagal connect wallet! Pastikan MetaMask terinstall.");
      }
    } else {
      alert("❌ MetaMask tidak ditemukan! Silakan install MetaMask.");
    }
  };

  // 🔹 FUNCTION: AMBIL DATA TOKEN (Balance, info, dll)
  const fetchTokenData = async (tokenContract, userAddress) => {
    try {
      console.log("📊 Fetching token data...");
      
      // 🔹 Ambil balance token user
      // balanceOf() adalah function di ERC20 untuk cek balance
      const userBalance = await tokenContract.balanceOf(userAddress);
      
      // 🔹 Format balance dari Wei ke unit normal
      // Karena decimals = 18, kita bagi 10^18
      const formattedBalance = ethers.formatUnits(userBalance, 18);
      setBalance(formattedBalance);
      console.log("💰 Balance:", formattedBalance, "DTK");

      // 🔹 Ambil info dasar token
      const tokenName = await tokenContract.name();
      const tokenSymbol = await tokenContract.symbol();
      const tokenDecimals = await tokenContract.decimals();
      const totalSupply = await tokenContract.totalSupply();
      
      console.log("📝 Token Info:", {
        name: tokenName,
        symbol: tokenSymbol,
        decimals: tokenDecimals,
        totalSupply: ethers.formatUnits(totalSupply, 18)
      });

    } catch (error) {
      console.error("❌ Error fetching token data:", error);
    }
  };

  // 🔹 FUNCTION: TRANSFER TOKEN KE ALAMAT LAIN
  const transferTokens = async () => {
    // Validasi input
    if (!token || !toAddress || !transferAmount) {
      alert("❌ Harap isi alamat penerima dan jumlah!");
      return;
    }

    try {
      console.log(`🔄 Transferring ${transferAmount} DTK to ${toAddress}...`);
      
      // 🔹 Convert amount dari string normal ke Wei (dengan 18 decimals)
      const amountInWei = ethers.parseUnits(transferAmount, 18);
      
      // 🔹 EKSEKUSI TRANSFER - Ini akan memunculkan popup konfirmasi MetaMask
      // transfer() adalah function ERC20 untuk kirim token
      const transaction = await token.transfer(toAddress, amountInWei);
      
      console.log("⏳ Transaction sent:", transaction.hash);
      alert(`✅ Transfer submitted! TX Hash: ${transaction.hash}`);
      
      // 🔹 TUNGGU KONFIRMASI BLOCKCHAIN
      // Ini penting untuk menunggu transaction benar-benar selesai
      await transaction.wait();
      console.log("✅ Transfer confirmed!");
      alert("🎉 Transfer berhasil!");
      
      // 🔹 UPDATE BALANCE SETELAH TRANSFER
      const newBalance = await token.balanceOf(account);
      setBalance(ethers.formatUnits(newBalance, 18));
      
      // 🔹 RESET FORM
      setToAddress('');
      setTransferAmount('');
      
    } catch (error) {
      console.error("❌ Transfer failed:", error);
      
      // Handle error spesifik
      if (error.code === 'INSUFFICIENT_FUNDS') {
        alert("❌ Balance tidak cukup!");
      } else if (error.code === 'ACTION_REJECTED') {
        alert("❌ Transfer dibatalkan oleh user");
      } else {
        alert("❌ Gagal transfer: " + error.message);
      }
    }
  };

  // 🔹 FUNCTION: MINT TOKEN BARU (Hanya untuk owner)
  const mintTokens = async () => {
    if (!token || !mintAmount) {
      alert("❌ Harap isi jumlah token!");
      return;
    }

    try {
      console.log(`🔄 Minting ${mintAmount} new DTK...`);
      
      // 🔹 Convert amount ke Wei
      const amountInWei = ethers.parseUnits(mintAmount, 18);
      
      // 🔹 MINT TOKEN - Hanya owner yang bisa
      const transaction = await token.mint(account, amountInWei);
      
      console.log("⏳ Mint transaction sent:", transaction.hash);
      alert(`✅ Mint submitted! TX Hash: ${transaction.hash}`);
      
      await transaction.wait();
      console.log("✅ Mint confirmed!");
      
      // Update balance
      const newBalance = await token.balanceOf(account);
      setBalance(ethers.formatUnits(newBalance, 18));
      
      setMintAmount('');

          alert(`🎉 Mint berhasil! \nToken baru berhasil ditambahkan.\nBalance sekarang: ${ethers.formatUnits(newBalance, 18)} DTK`);
      
    } catch (error) {
      console.error("❌ Mint failed:", error);
    
          // 🔹 ERROR HANDLING DETAIL
    if (error.message.includes("only owner") || error.message.includes("Ownable")) {
      alert("❌ Gagal mint! Hanya contract owner yang bisa mint token.");
    } else if (error.code === 'ACTION_REJECTED' || error.message.includes("user rejected")) {
      alert("❌ Mint dibatalkan oleh user.");
    } else if (error.message.includes("revert")) {
      alert("❌ Transaction failed! Contract reverted the transaction.");
    } else {
      alert("❌ Gagal mint: " + error.message);
    }
  }
};

  // 🔹 [TAMBAH] FUNCTION: CEK OWNER CONTRACT - TEMPATKAN DI SINI!
const checkContractOwner = async () => {
  if (!token) {
    alert("❌ Connect wallet dulu!");
    return;
  }

  try {
    console.log("🔍 Checking contract owner...");
    
    const ownerAddress = await token.owner();
    const currentUser = account;
    
    console.log("👑 Contract Owner:", ownerAddress);
    console.log("👤 Your Address:", currentUser);
    
    if (ownerAddress.toLowerCase() === currentUser.toLowerCase()) {
      alert("✅ Anda adalah contract owner! Bisa menggunakan mint function.");
    } else {
      alert(`❌ Anda BUKAN contract owner.\n\nOwner: ${ownerAddress}\nAnda: ${currentUser}\n\nHanya owner yang bisa mint token.`);
    }
    
  } catch (error) {
    console.error("❌ Error checking owner:", error);
    alert("❌ Gagal cek owner: " + error.message);
  }
};

  // 🔹 FUNCTION: DISCONNECT WALLET
  const disconnectWallet = () => {
    setAccount('');
    setToken(null);
    setBalance('0');
    setIsConnected(false);
    setToAddress('');
    setTransferAmount('');
    setMintAmount('');
    console.log("🔌 Wallet disconnected");
  };

  // 🔹 USE EFFECT: Listen untuk account changes di MetaMask
  useEffect(() => {
    // Jika user ganti account di MetaMask, update otomatis
    if (window.ethereum) {
      window.ethereum.on('accountsChanged', (accounts) => {
        if (accounts.length > 0) {
          setAccount(accounts[0]);
          console.log("🔄 Account changed to:", accounts[0]);
        } else {
          disconnectWallet();
        }
      });
    }
  }, []);

  return (
    <div className="App">
      {/* 🔹 HEADER */}
      <header className="App-header">
        <h1>🚀 Deepthink Token DApp</h1>
        <p>Manage your DTK tokens  on {network}</p>
      </header>

      {/* 🔹 MAIN CONTENT */}
      <div className="container">
        {/* 🔹 WALLET CONNECTION SECTION */}
        {!isConnected ? (
          <div className="connect-section">
            <h2>Connect Your Wallet</h2>
            <p>Connect MetaMask to start using Deepthink Token</p>
            <button className="connect-btn" onClick={connectWallet}>
              🦊 Connect MetaMask
            </button>
          </div>
        ) : (
          <div className="dashboard">
            {/* 🔹 WALLET INFO SECTION */}
            <div className="wallet-info">
              <h2>💰 Wallet Information</h2>
              <p><strong>Connected Address:</strong> {account}</p>
              <p><strong>DTK Balance:</strong> {balance} DTK</p>
              <button className="disconnect-btn" onClick={disconnectWallet}>
                🔌 Disconnect
              </button>
            </div>

            {/* 🔹 TRANSFER SECTION */}
            <div className="transfer-section">
              <h2>🔄 Transfer Tokens</h2>
              <div className="input-group">
                <input 
                  type="text" 
                  placeholder="Recipient Address (0x...)" 
                  value={toAddress}
                  onChange={(e) => setToAddress(e.target.value)}
                  className="address-input"
                />
                <input 
                  type="text" 
                  placeholder="Amount DTK" 
                  value={transferAmount}
                  onChange={(e) => setTransferAmount(e.target.value)}
                  className="amount-input"
                />
                <button onClick={transferTokens} className="transfer-btn">
                  📤 Transfer
                </button>
              </div>
            </div>

            {/* 🔹 MINT SECTION (Hanya untuk owner) */}
            <div className="mint-section">
              <h2>🛠️ Mint Tokens (Owner Only)</h2>
              <p><small>Hanya contract owner yang bisa mint token baru</small></p>
              <div className="input-group">
                <input 
                  type="text" 
                  placeholder="Amount DTK to mint" 
                  value={mintAmount}
                  onChange={(e) => setMintAmount(e.target.value)}
                  className="amount-input"
                />
                <button onClick={mintTokens} className="mint-btn">
                  🏭 Mint
                </button>
              </div>
            </div>

            {/* 🔹 [TAMBAH] ADMIN SECTION */}
<div className="admin-section">
  <h2>👑 Admin Tools</h2>
  <div className="admin-buttons">
    <button onClick={checkContractOwner} className="admin-btn">
      🔍 Check Owner Status
    </button>
  </div>
  <small>Verify apakah Anda contract owner untuk menggunakan mint function</small>
</div>

            {/* 🔹 CONTRACT INFO */}
            <div className="contract-info">
              <h2>📋 Contract Information</h2>
              <p><strong>Contract Address:</strong> {contractAddress}</p>
              <p><strong>Network:</strong> Sepolia Testnet</p>
              <a 
                href={`https://sepolia.etherscan.io/address/${contractAddress}`} 
                target="_blank" 
                rel="noopener noreferrer"
                className="etherscan-link"
              >
                🔍 View on Etherscan
              </a>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default App;